import { useState } from "react";

import { Button } from "capitalrx-components-2.0/lib/general";
import { Shelf, useResponsive } from "capitalrx-components-2.0/lib/layout";

import "./TabHeaderButtons.scss";

interface TabHeaderButtonsProps {
  readonly onChange: (value: number) => void;
  readonly tabTitles: string[];
  readonly value?: number;
}

export const TabHeaderButtons = ({ onChange, tabTitles, value = 0 }: TabHeaderButtonsProps) => {
  const [currentTabIndex, setCurrentTabIndex] = useState<number>(value ?? 0);

  const handleTabChange = (tabIndex: number) => {
    setCurrentTabIndex(tabIndex);
    onChange(tabIndex);
  };

  const { sizing } = useResponsive({
    sizing: {
      mobile: "mobileToggle",
      tablet: "tabletToggle",
      desktop: "desktopToggle",
    },
  });

  return (
    <div className={`tabHeaderButtonContainer ${sizing}`}>
      <Shelf spacing="small">
        {
          tabTitles.map((title, index) => (
            <Button
              key={index}
              tabIndex={index}
              className="networkToggleButton"
              appearance={currentTabIndex === index ? "primary" : "text"}
              onClick={() => handleTabChange(index)}
            >
              {title}
            </Button>
          ))
        }
      </Shelf>
    </div>
  );
};
